/* eslint-disable react/prop-types */
// product is the shared catalog shape used throughout src/lib/db.js, not
// re-declared per component.
import React from "react";

import { Fade } from "react-awesome-reveal";

import NotFound from "assets/images/NotFound.png";

import Button from "elements/Button";

const BackLink = () => (
  <Button
    type="link"
    href="/product"
    className="ml-6 mt-8 flex w-fit items-center text-lg font-light text-slate-400 hover:text-maroon-700 hover:underline sm:ml-20"
  >
    <svg className="mr-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
    </svg>
    See All Products
  </Button>
);

export default function PortfolioDetail({ product, isLoading }) {
  if (isLoading) {
    return (
      <section className="container mx-auto">
        <BackLink />
        <div className="mx-auto mt-10 h-96 max-w-3xl animate-pulse rounded-2xl bg-slate-100" />
      </section>
    );
  }

  if (!product) {
    return (
      <section className="container mx-auto">
        <Fade bottom triggerOnce>
          <div className="flex w-full flex-col justify-center">
            <div className="flex w-full justify-center">
              <img src={NotFound} alt="Product not found" loading="lazy" className="mt-5 sm:w-3/4 xl:w-5/12" />
            </div>
            <h1 className="mt-5 text-center text-2xl text-maroon-800">Product Not Found</h1>
            <div className="flex justify-center">
              <Button
                href="/product"
                type="link"
                className="mt-5 flex h-10 items-center rounded-lg bg-maroon-700 px-5 text-white transition-colors hover:bg-maroon-800"
              >
                Go Back
              </Button>
            </div>
          </div>
        </Fade>
      </section>
    );
  }

  return (
    <section className="container mx-auto">
      <Fade bottom triggerOnce>
        <BackLink />
      </Fade>

      <div className="mt-8 flex flex-col justify-center">
        <Fade bottom triggerOnce>
          <p className="text-center text-sm font-semibold uppercase tracking-widest text-gold-700">
            {product.type}
          </p>
          <h1 className="mt-2 text-center font-display text-4xl text-maroon-900 sm:text-5xl">
            {product.title}
          </h1>
        </Fade>

        <Fade bottom delay={200} triggerOnce>
          <div className="mt-10 flex justify-center xl:mb-6">
            <div className="flex h-80 w-full max-w-md items-center justify-center rounded-2xl border border-slate-100 bg-white p-8 shadow-lg sm:h-96">
              {product.image_url ? (
                <img
                  src={product.image_url}
                  alt={product.title}
                  loading="lazy"
                  className="h-full w-full object-contain"
                />
              ) : (
                <span className="text-slate-300">No image yet</span>
              )}
            </div>
          </div>
        </Fade>

        <Fade bottom delay={300} triggerOnce>
          <div className="mx-8 mb-16 mt-14 sm:mx-16 xl:mx-28">
            <h2 className="mb-4 text-2xl font-bold text-maroon-800">Available Packaging</h2>
            {product.packaging?.length ? (
              <div className="flex flex-wrap gap-3">
                {product.packaging.map((pack) => (
                  <span
                    key={pack}
                    className="rounded-full border border-maroon-200 px-5 py-2 text-maroon-700 shadow-sm"
                  >
                    {pack}
                  </span>
                ))}
              </div>
            ) : (
              <p className="text-slate-400">Contact us for available packaging and pricing.</p>
            )}

            <div className="mt-10 rounded-2xl bg-maroon-50 p-6 sm:p-8">
              <h3 className="text-lg font-semibold text-maroon-800">Interested in bulk or custom bottling?</h3>
              <p className="mt-1 text-slate-500">
                We supply {product.title.toLowerCase()} in bulk and can tailor
                packaging to your brand.
              </p>
              <Button
                href="/contact-us"
                type="link"
                className="mt-4 inline-flex rounded-full bg-maroon-700 px-6 py-2.5 font-semibold text-white transition-colors hover:bg-maroon-800"
              >
                Request a Quote
              </Button>
            </div>
          </div>
        </Fade>
      </div>
    </section>
  );
}
